module.exports = __webpack_public_path__ + "4b2a491429be27cea527eb2b307ad6e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C00003ANP.png
// module id = 1672
// module chunks = 0